import ShippingInquiryFA from './fa/fa.json'

const ShippingInquiryMessages = {
  fa: { ...ShippingInquiryFA },
}

export default ShippingInquiryMessages
